import React, { useState } from "react";
import fetchData from '../../api/fetchApi';

export default function AddUserPage() {

  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});

  return (
    <div className="min-h-screen p-6 bg-gray-50" dir="rtl">
      <div className="mx-auto">
        <div className="text-lg font-semibold mb-4">اضافة مستخدم جديد</div>
        <form
          className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 space-y-6"
          onSubmit={async (e) => {
            e.preventDefault();
            try {
              setError("");
              setFieldErrors({});
              const body = { name, username, phone, email, password };
              await fetchData('users', 'POST', body);
              // Optionally reset form or redirect
            } catch (error) {
              console.error("Failed to add user:", error);
              if (error.errors) {
                setFieldErrors(error.errors);
                setError(error.message || "");
              } else if (error.message) {
                setError(error.message);
              } else {
                setError("حدث خطأ أثناء إضافة المستخدم.");
              }
            }
          }}
        >
          <div>
          {error && (
            <div className="mb-4 text-red-600 bg-red-50 border border-red-200 rounded-lg p-3 text-sm">
              {error}
            </div>
          )}
          <label className="block text-sm text-gray-600 mb-1">الاسم</label>
          <input value={name} onChange={e => setName(e.target.value)} className="w-full rounded-lg border border-gray-200 p-3" />
          {fieldErrors.name && (
            <div className="text-xs text-red-600 mt-1">{fieldErrors.name[0]}</div>
          )}
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">اسم المستخدم</label>
            <input value={username} onChange={e => setUsername(e.target.value)} className="w-full rounded-lg border border-gray-200 p-3" />
            {fieldErrors.username && (
              <div className="text-xs text-red-600 mt-1">{fieldErrors.username[0]}</div>
            )}
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">رقم الهاتف</label>
            <input value={phone} onChange={e => setPhone(e.target.value)} className="w-full rounded-lg border border-gray-200 p-3" />
            {fieldErrors.phone && (
              <div className="text-xs text-red-600 mt-1">{fieldErrors.phone[0]}</div>
            )}
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">البريد الإلكتروني</label>
            <input value={email} onChange={e => setEmail(e.target.value)} className="w-full rounded-lg border border-gray-200 p-3" />
            {fieldErrors.email && (
              <div className="text-xs text-red-600 mt-1">{fieldErrors.email[0]}</div>
            )}
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">كلمة السر</label>
            <input type="password" min={'8'} value={password} onChange={e => setPassword(e.target.value)} className="w-full rounded-lg border border-gray-200 p-3" />
            {fieldErrors.password && (
              <div className="text-xs text-red-600 mt-1">{fieldErrors.password[0]}</div>
            )}
          </div>
          <div className="flex items-center justify-between mt-8">
            <button type="button" className="px-6 py-3 rounded-lg border bg-gray-100">إلغاء</button>
            <button type="submit" className="px-6 py-3 rounded-lg bg-[var(--Primary-Primary)] text-white">اضافة المستخدم</button>
          </div>
        </form>
      </div>
    </div>
  );
}
